var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDelete(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    width: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#746780",
    d: "M14.608 7.151h1.25V18.79h-1.25zm-3.233 0h1.25V18.79h-1.25zm-3.233 0h1.25V18.79h-1.25zm-1.983-1.96V20.75h11.682V5.19h-3.277v.021h-1.25v-.02h-2.629v.02h-1.25v-.02zm6.995-1.942l-2.318.001c-.036.016-.151.163-.151.41v.28h2.63v-.28c0-.247-.115-.394-.16-.411zM10.836 2h2.328c.785 0 1.4.73 1.4 1.66v.28h5.195v1.25h-.668v15.56c0 .69-.56 1.25-1.25 1.25H6.159c-.69 0-1.25-.56-1.25-1.25V5.19h-.668V3.94h5.194v-.28c0-.93.616-1.66 1.401-1.66z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default ForwardRef;